const START_YEAR = 2022;
const END_YEAR = new Date().getFullYear() + 1;

export const yearMonths = [];

for (let year = START_YEAR; year <= END_YEAR; year += 1) {
  for (let month = 1; month <= 12; month += 1) {
    const firstDay = new Date(year, month - 1, 1);
    const daysInMonth = new Date(year, month, 0).getDate();

    yearMonths.push({
      id: String((year - START_YEAR) * 12 + month),
      year: String(year),
      month: String(month),
      show: `${year}年${month}月`,
      day: String(daysInMonth),
      week: String(firstDay.getDay() || 7),
      format: `${year}-${String(month).padStart(2, "0")}`,
    });
  }
}
